import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../../ui-components/modal/base-modal-component';
import { SharedModule } from '../../../../ui-components/shared.module';
import { CloseBtnComponent } from '../../../../@components/close-btn/close-btn.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'vw-ai-chatbot-info-modal',
    imports: [SharedModule, CloseBtnComponent, TranslateModule],
    templateUrl: './ai-chatbot-info-modal.component.html',
    styleUrl: './ai-chatbot-info-modal.component.scss'
})
export class AiChatbotInfoModalComponent extends BaseModalComponent {
  constructor() {
    super();
  }

}
